export function getImageUrl(path: string, apiBaseUrl?: string | null): string {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  if (path.startsWith('/api/v1/')) {
    if (apiBaseUrl) {
      const trimmedBaseUrl = apiBaseUrl.replace(/\/+$/, '');
      return `${trimmedBaseUrl}/image-proxy?path=${encodeURIComponent(path)}`;
    }

    return `/wapi/ai-helper/image-proxy?path=${encodeURIComponent(path)}`;
  }

  return path;
}
